export default function formatDate(date, showHours = false)
{
    const newDate = new Date(date)
    const options = showHours ? { hour: 'numeric', minute: 'numeric' } :  {}

    return newDate.toLocaleDateString('pt-BR', options);
}